import { useEffect, useState } from 'react';

function usePageLoaded() {
    const [pageLoaded, setPageLoaded] = useState(false);
    useEffect(() => {
        const onPageLoad = () => {
            setPageLoaded(true);
        };

        // Check if the page has already loaded
        if (document.readyState === 'complete') {
            onPageLoad();
        } else {
            window.addEventListener('load', onPageLoad);
            // Remove the event listener when component unmounts
            return () => window.removeEventListener('load', onPageLoad);
        }
    }, []);

    return pageLoaded;
}

export default usePageLoaded;
